export const UpdateStatus = Object.freeze({
  ERROR: 0,
  PROCESS: 1,
  COMPLETE: 2,
  UNUPLOAD: 3,
});
